<template>
  <router-link
    :to="{
      name: 'invoices.show',
      params: { invoice_id: invoice.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Invoice #:</span>
          <span class="strong">{{ invoice.xero_number }}</span>
        </p>
      </div>
      <div class="col-12 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Invoice #:</span>
          <span class="strong">{{ invoice.stack_invoice.month | moment('MMM YYYY') }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Staus:</span>
          <span
            v-bind:class="invoice.status == 'PAID' ? 'status-success' : 'status-mute'"
            class="status"
            >{{ invoice.status }}</span
          >
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Total:</span>
          <span>$ {{ invoice.total | currency }}</span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    invoice: {
      required: true,
      type: Object,
    },
  }
};
</script>
